'use strict';
import React from 'react';
import SummaryList from './summaryList';
import { Link } from 'react-router-dom';
import leaveAction from '../../actions/leaveAction';

class SummaryBody extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    static defaultProps = {
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    };

    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            window.print();
        } else if (index == 1) {
            if (this.props.processing) return;
            leaveAction.processing(true);
            leaveAction.exportSummary(this.props.summary.staffId);
        } else {
            this.props.history.push('/leaveInfo');
        }
    }
    render() {
        let summary;
        if (this.props.summary.summary) {
            summary = this.props.summary.summary.map((summary, index) => {
                return (
                    <th key={index}>{summary.leaveTxt} ({summary.type == 7 ? "hrs" : "days"})</th>
                );
            });
        }



        return (

            <div id="leaveSummary">
                <h3>Leave Summary</h3>
                <div className="sum-1-wp">
                    <h4><b>{this.props.summary.userName}</b></h4>
                    <br />
                    <div className="sum-wp" style={{ width: (this.props.summary.summary ? this.props.summary.summary.length * 110 + 110 : 0) + "px" }}>
                        <div className="sum-l-tt">
                        </div>
                        <table className="sum-tb">
                            <thead>
                                <tr>
                                    {summary}
                                </tr>
                            </thead>
                        </table>
                        <SummaryList summary={this.props.summary.summary} />
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <button type="button" className="btn btn-primary us-cr"
                                data-index="0" onClick={this.handleClick}>Print</button>
                            <button type="button" className="btn btn-primary us-cr"
                                data-index="1" onClick={this.handleClick}>Export</button>
                            <button type="button" className="btn btn-default us-cr"
                                data-index="2" onClick={this.handleClick}>Cancel</button>
                        </div>
                        <div className="clear"></div>
                    </div>
                </div>
            </div>
        );
    }
}
export default SummaryBody;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/summaryBody.js